import React from "react";
import "./experience-item.scss";

export const ExperienceItem = (props: ExperienceItemType) => {
  return (
    <div className="experience__item p-1">
      <hr />
      <div className="row p-2">
        <div className="col-md-2">
          <h6 className="experience__item__date__range">
            {props.startDate} - {props.endDate}
          </h6>
        </div>
        <div className="col-md-10">
          <h2 className="experience__item__title">{props.title}</h2>
          <div className="experience__item__job_desc">
            <small className="experience__item__subtitle">
              {props.subTitle}
            </small>
            <span> | </span>
            <small className="experience__item__subtitle">
              {props.jobType}
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export type ExperienceItemType = {
  id: string | number;
  title: string;
  subTitle: string;
  jobType: string;
  startDate: number;
  endDate: number | string;
};
